import React from 'react'
import { Text } from 'theme-ui'
import TextList from '@components/TextList'
import { FaRegClock } from 'react-icons/fa'
import rv from '@components/utils/buildResponsiveVariant'
import { translateDateBlog } from '../CardEducabot/Card.Footer.Info'

const CardFooterInfo = ({ variant, date, timeToRead }) => (
  <TextList nowrap>
    {date && <Text sx={{ variant: rv(variant, 'date'), color: '#6B6767' }}>{translateDateBlog(date)}</Text>}
    {/* ESTO AGREGA EL RELOJ */}
    {/* {timeToRead && (
      <Text sx={{ variant: rv(variant, 'timeToRead'), color: '#6B6767' }}>
        <FaRegClock css={{ verticalAlign: `middle`, color: '#6B6767' }} /> {timeToRead} min
      </Text>
    )} */}
  </TextList>
)

export default CardFooterInfo
